import gql from 'graphql-tag';

export const updateCommercialFacilityNote = gql`
  mutation updateCommercialFacilityNote(
    $id: ID!
    $input: CommercialFacilityNoteInput!
  ) {
    updateCommercialFacilityNote(id: $id, input: $input) {
      id
      commercialFacilityId
      note
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
      version
    }
  }
`;
